/*
 * Created Date: 29-01-2024, 2:15:59 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Feb 29 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */
import { FaUser, FaUserCog } from 'react-icons/fa'
import { LuSettings, LuUserCircle } from 'react-icons/lu'
import { ROUTER_MY_ACCOUNT } from './const'
import { GrUserSettings } from 'react-icons/gr'
const MyAccountNavigationConfig = {
	id: 'my-account',
	title: 'Tài khoản của bạn',
	type: 'collapse',
	icon: <FaUser className="text-[1.4rem]" />,
	children: [
		{
			id: 'profile',
			title: 'Cài đặt',
			type: 'item',
			icon: <FaUserCog className="text-[1.2rem]" />,
			link: ROUTER_MY_ACCOUNT.profile
		}
	]
}

export default MyAccountNavigationConfig
